<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="24">
        <h-three :title="$lang.flexColumns" />
      </flex-col>
      <flex-col :span="24">
        <container>
          <flex :spacing="spacing">
            <flex-col :span="24" v-ripple>
              <div :class="[colDisplay, 'bg-red-500']">24</div>
            </flex-col>
          </flex>
          <flex :spacing="spacing">
            <flex-col v-for="i in 2" :span="12" :key="i" v-ripple>
              <div :class="[colDisplay, 'bg-yellow-500']">12</div>
            </flex-col>
          </flex>
          <flex :spacing="spacing">
            <flex-col v-for="i in 3" :span="8" :key="i" v-ripple>
              <div :class="[colDisplay, 'bg-green-500']">8</div>
            </flex-col>
          </flex>
          <flex :spacing="spacing">
            <flex-col v-for="i in 4" :span="6" :key="i" v-ripple>
              <div :class="[colDisplay, 'bg-indigo-500']">6</div>
            </flex-col>
          </flex>
          <flex :spacing="spacing">
            <flex-col v-for="i in 6" :span="4" :key="i" v-ripple>
              <div :class="[colDisplay, 'bg-pink-500']">4</div>
            </flex-col>
          </flex>
          <flex :spacing="spacing">
            <flex-col v-for="i in 8" :span="3" :key="i" v-ripple>
              <div :class="[colDisplay, 'bg-purple-500']">3</div>
            </flex-col>
          </flex>
          <flex :spacing="spacing">
            <flex-col v-for="i in 12" :span="2" :key="i" v-ripple>
              <div :class="[colDisplay, 'bg-gray-500']">2</div>
            </flex-col>
          </flex>
          <flex :spacing="spacing">
            <flex-col v-for="i in 24" :span="1" :key="i" v-ripple>
              <div :class="[colDisplay, 'bg-red-500']">1</div>
            </flex-col>
          </flex>
        </container>
      </flex-col>
      <flex-col :span="24">
        <h-three :title="$lang.breakpoints" />
      </flex-col>
      <flex-col :span="24">
        <paragraph v-html="$lang.resizeTheWindowFlex" />
        <container>
          <flex :spacing="spacing" v-resize="resize" :class="['text-center']">
            <flex-col :span="1" v-for="index in 24" :key="`flex-col-${index}`" xs24 sm12 md6 lg2 xl1 v-ripple>
              <div :class="[colDisplay, breakpoint.color || 'red']">{{ breakpoint.name }}: {{ breakpoint.width }}</div>
            </flex-col>
          </flex>
        </container>
      </flex-col>
      <flex-col :span="24">
        <h-three :title="$lang.complexLayous" />
      </flex-col>
      <flex-col :span="24">
        <container>
          <flex :spacing="spacing">
            <flex-col :span="4" v-ripple>
              <div :class="[colDisplay, 'bg-red-500']">4</div>
            </flex-col>
            <flex-col :span="16" v-ripple>
              <div :class="[colDisplay, 'bg-red-500']">16</div>
            </flex-col>
            <flex-col :span="4" v-ripple>
              <div :class="[colDisplay, 'bg-red-500']">4</div>
            </flex-col>
          </flex>
          <flex :spacing="spacing">
            <flex-col :span="5" v-ripple>
              <div :class="[colDisplay, 'bg-yellow-500']">5</div>
            </flex-col>
            <flex-col :span="19" :spacing="spacing" v-ripple>
              <div :class="[colDisplay, 'bg-yellow-500']">19</div>
            </flex-col>
          </flex>
          <flex :spacing="spacing">
            <flex-col :span="9" v-ripple>
              <div :class="[colDisplay, 'bg-green-500']">9</div>
            </flex-col>
            <flex-col :span="6" v-ripple>
              <div :class="[colDisplay, 'bg-green-500']">6</div>
            </flex-col>
            <flex-col :span="9" v-ripple>
              <div :class="[colDisplay, 'bg-green-500']">9</div>
            </flex-col>
          </flex>
          <flex :spacing="spacing">
            <flex-col :span="9" v-ripple>
              <div :class="[colDisplay, 'bg-indigo-500']">9</div>
            </flex-col>
            <flex-col :span="3" v-ripple>
              <div :class="[colDisplay, 'bg-indigo-500']">3</div>
            </flex-col>
            <flex-col :span="12" v-ripple>
              <div :class="[colDisplay, 'bg-indigo-500']">12</div>
            </flex-col>
          </flex>
          <flex :spacing="spacing">
            <flex-col :span="11" v-ripple>
              <div :class="[colDisplay, 'bg-blue-500']">11</div>
            </flex-col>
            <flex-col :span="11" v-ripple>
              <div :class="[colDisplay, 'bg-blue-500']">11</div>
            </flex-col>
            <flex-col :span="2" v-ripple>
              <div :class="[colDisplay, 'bg-blue-500']">2</div>
            </flex-col>
          </flex>
        </container>
      </flex-col>
      <flex-col :span="24">
        <h-three :title="$lang.flexModifiers" />
        <paragraph v-html="$lang.flexModifiersInfo" />
        <table-layout tag="table" :class="['api-explorer-doc-table', 'text-xs']" y-align="middle" x-align="center">
          <row tag="tr">
            <cell tag="th" v-for="(breakpoint, index) in breakpoints" :key="index" :class="['p-3']">
              <div v-html="breakpoint.name" :class="['mb-2']" />
              <div v-html="$lang.size(breakpoint.width)" />
            </cell>
          </row>
          <row tag="td" v-for="(size, index) in 24" :key="index">
            <cell tag="td" :class="['p-3']" v-for="(breakpoint, i) in breakpoints" :key="i">
              <code v-html="`[${breakpoint.name + size}]`" />
            </cell>
          </row>
        </table-layout>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageFlex',
  mixins: [
    methods
  ],
  data () {
    return {
      spacing: 3,
      breakpoint: null,
      colDisplay: ['col-display', 'shadow-sm', 'text-center'],
      breakpoints: [{
        name: 'xl',
        width: 1920,
        color: 'bg-red-500'
      }, {
        name: 'lg',
        width: 1440,
        color: 'bg-green-500'
      }, {
        name: 'md',
        width: 1024,
        color: 'bg-yellow-500'
      }, {
        name: 'sm',
        width: 960,
        color: 'bg-indigo-500'
      }, {
        name: 'xs',
        width: 480,
        color: 'bg-pink-500'
      }]
    }
  },
  created () {
    this.breakpoint = this.breakpoints[0]
  },
  methods: {
    resize () {
      const width = this.viewport().width
      const breakpoints = this.breakpoints
      if (width >= 1920) {
        this.breakpoint = breakpoints[0]
      } else if (width >= 1024 && width < 1920) {
        this.breakpoint = breakpoints[1]
      } else if (width >= 960 && width < 1024) {
        this.breakpoint = breakpoints[2]
      } else if (width >= 480 && width < 960) {
        this.breakpoint = breakpoints[3]
      } else if (width <= 480) {
        this.breakpoint = breakpoints[4]
      }
    }
  }
}
</script>
<style>
.col-display
{
  padding: 8px;
  border-radius: 2px;
  color: #fff;
  font-size: 12px;
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/pages/content/flex.vue